<template>
  <div id="app">
    <div v-for="(link, i) in prismicLinks" :key="'a' + i">
      <p><a :href="link.data.project_link.url">{{ link.data.project_name }}</a> | {{ link.data.display_date }}</p>
    </div>

    <br>
    <br>
    
    <p>againwewander at gmail</p>
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      prismicLinks: [] 
    }
  },
  methods: {
    getContent () {
      this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'app-link-description'),
        { orderings : '[my.app-link-description.sort_date desc]' }
      ).then((response) => {
        this.prismicLinks = response.results
        // response is the response object, response.results holds the documents
      })
    }
  },
  created () {
    this.getContent();
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
